export default    
	{
        path:'/subjectDiagnosis',
        name:'选科诊断',
        redirect:'/subjectDiagnosis/main',
        component:()=>import('../views/subjectDiagnosis/index'),
        meta:{requireAuth:true,roles:['student']},
        children:[
            {
                path:'/subjectDiagnosis/main',
                name:'选科诊断',
                component:()=>import('../views/subjectDiagnosis/main'),
                meta:{requireAuth:true,roles:['student']},
            },
            // {
            //     path:'/strongBase/course',
            //     name:'我的视频课程',
            //     component:()=>import('../views/strongBase/course'),
            //     meta:{requireAuth:true,roles:['student']},
            // },

        ]
    }